"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Level = exports.BlankCard = exports.SponsorCard = exports.SponsorsLevel = exports.SponsorsGrid = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importDefault(require("react"));

var sponsors_grid_styled_1 = require("./sponsors-grid.styled");

var Level;

(function (Level) {
  Level["Gold"] = "gold";
  Level["Silver"] = "silver";
  Level["Bronze"] = "bronze";
  Level["Tier4"] = "tier 4";
  Level["Tier5"] = "tier 5";
  Level["Tier6"] = "tier 6";
  Level["Tier7"] = "tier 7";
  Level["Tier8"] = "tier 8";
  Level["Tier9"] = "tier 9";
  Level["Tier10"] = "tier 10";
})(Level || (Level = {}));

exports.Level = Level;
var Levels = (_a = {}, _a[Level.Gold] = {
  color: '#E2A514',
  desktopColumns: 3,
  mobileColumns: 2
}, _a[Level.Silver] = {
  color: '#979BA8',
  desktopColumns: 4,
  mobileColumns: 3
}, _a[Level.Bronze] = {
  color: '#EC9D52',
  desktopColumns: 6,
  mobileColumns: 4
}, _a['default'] = {
  color: '#979BA8',
  desktopColumns: 6,
  mobileColumns: 4
}, _a);

function SponsorCard(props) {
  return react_1.default.createElement(sponsors_grid_styled_1.StyledSponsorCard, tslib_1.__assign({
    href: props.url,
    target: "_blank"
  }, props), react_1.default.createElement("div", {
    className: "card-content"
  }, react_1.default.createElement("img", {
    src: props.imageUrl,
    alt: props.name,
    title: props.name
  })), props.children);
}

exports.SponsorCard = SponsorCard;

function BlankCard(props) {
  return react_1.default.createElement(sponsors_grid_styled_1.StyledSponsorCard, tslib_1.__assign({
    as: "button",
    blank: true
  }, props), react_1.default.createElement(ui_icon_1.Icon, {
    scale: 3,
    name: "plus",
    description: "Add a new sponsor",
    title: "Plus",
    color: "grey-600"
  }));
}

exports.BlankCard = BlankCard;

function SponsorsLevel(props) {
  var levelInfo = Levels[props.level] || Levels['default'];
  return react_1.default.createElement("div", null, !props.hideLabel && react_1.default.createElement(sponsors_grid_styled_1.StyledSponsorsLevelHeader, {
    backgroundColor: levelInfo.color,
    "data-color": levelInfo.color
  }, props.label || props.level), react_1.default.createElement(sponsors_grid_styled_1.StyledSponsorsLevel, tslib_1.__assign({
    desktopColumns: levelInfo.desktopColumns,
    mobileColumns: levelInfo.mobileColumns,
    ref: props.cardsRef
  }, props), props.children));
}

exports.SponsorsLevel = SponsorsLevel;

function SponsorsGrid(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      children = _a.children;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: SponsorsLevel.name,
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement("div", {
    className: rootClasses
  }, children);
}

exports.SponsorsGrid = SponsorsGrid;